import { AbstractParser } from "../../parser";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";
import { UserPermission } from "src/app/ui/models/domains/pbm/user/user-permission";

export class RequestUserRolesParser extends AbstractParser<UserRole[]> {
  parse(payload: any): UserRole[] {
    const userRoleList: UserRole[] = payload.map((userRoleItem) => {
      const userRole = new UserRole();
      userRole.setUserRoleKey(userRoleItem.UserRoleKey.Value);
      userRole.setName(userRoleItem.Name);
      userRole.setUserPermissionList(this.parseUserPermissionList(userRoleItem.UserPermissions));
      userRole.setUserRoleType(userRoleItem.UserRoleType);
      return userRole;
    });
    return userRoleList;
  }

  private parseUserPermissionList(payload: any): UserPermission[] {
    const userPermissionList: UserPermission[] = payload.map((userPermissionItem) => {
      const userPermission = new UserPermission();
      userPermission.setUserPermissionKey(userPermissionItem.UserPermissionKey.Value);
      userPermission.setName(userPermissionItem.Name);
      userPermission.setCode(userPermissionItem.Code);
      userPermission.setUserRoleType(userPermissionItem.UserRoleType);
      return userPermission;
    });
    return userPermissionList;
  }
}
